import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@tsin-env/environment';
import { Observable } from 'rxjs';
import { UpdateUserPreferencesDTO, UserPreferencesModel } from './user-preferences.types';

const API_URI = `${environment.apiBaseUrl}/user-preferences`;

@Injectable({
  providedIn: 'root',
})
export class UserPreferencesService {
  http: HttpClient = inject(HttpClient);

  /**
   * Get current user's job alert preferences
   */
  getPreferences(): Observable<UserPreferencesModel> {
    return this.http.get<UserPreferencesModel>(API_URI);
  }

  /**
   * Update current user's job alert preferences
   */
  updatePreferences(dto: UpdateUserPreferencesDTO): Observable<UserPreferencesModel> {
    return this.http.put<UserPreferencesModel>(API_URI, dto);
  }
}
